import _ from "lodash";

export type Difficulty = "easy" | "medium" | "hard";

export const BLANK_BOARD = Array(9)
  .fill(null)
  .map(() => Array(9).fill(0));

export const isValid = (
  board: number[][],
  row: number,
  col: number,
  num: number,
) => {
  for (let i = 0; i < 9; i++) {
    if (board[row][i] === num || board[i][col] === num) return false;
  }
  const startRow = Math.floor(row / 3) * 3;
  const startCol = Math.floor(col / 3) * 3;
  for (let i = 0; i < 3; i++) {
    for (let j = 0; j < 3; j++) {
      if (board[startRow + i][startCol + j] === num) return false;
    }
  }
  return true;
};

export const solveSudoku = (board: number[][]): boolean => {
  for (let row = 0; row < 9; row++) {
    for (let col = 0; col < 9; col++) {
      if (board[row][col] === 0) {
        for (let num = 1; num <= 9; num++) {
          if (isValid(board, row, col, num)) {
            board[row][col] = num;
            if (solveSudoku(board)) return true;
            board[row][col] = 0;
          }
        }
        return false;
      }
    }
  }
  return true;
};

export const generateBoard = (difficulty: Difficulty) => {
  const board = _.cloneDeep(BLANK_BOARD);
  for (let i = 0; i < 9; i += 3) {
    for (let j = 0; j < 3; j++) {
      for (let k = 0; k < 3; k++) {
        let num;
        do {
          num = Math.floor(Math.random() * 9) + 1;
        } while (!isValid(board, i + j, i + k, num));
        board[i + j][i + k] = num;
      }
    }
  }
  solveSudoku(board);
  const solution = _.cloneDeep(board);

  const attempts =
    difficulty === "easy" ? 30 : difficulty === "medium" ? 45 : 55;
  for (let i = 0; i < attempts; i++) {
    let r = Math.floor(Math.random() * 9);
    let c = Math.floor(Math.random() * 9);
    board[r][c] = 0;
  }

  return { initial: board, solution };
};
